/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as Msdyn365 from '@msdyn365-commerce/core';

/**
 * GetDevices Input Action
 */
export class GetDeviceDetailsInput implements Msdyn365.IActionInput {
    constructor() {}

    public getCacheKey = (): string => `GetDeviceDetailsKey`;
    public getCacheObjectType = (): string => 'GetDeviceDetails';
    public dataCacheType = (): Msdyn365.CacheType => 'application';
}

export interface ICipDeviceDetails {
    '@odata.context': string;
    ActiveFromDate: string;
    Name: string;
    Id: string;
    AssetId: string;
    Model: string;
    ModelYear: string;
    StatusCode: string;
    StatusCodeFormatted: string;
    Location: string;
    ParentName: string;
    ProductName: string;
    ProductNumber: string;
    Acquisitiondate: string;
    NewGuaranteestartdate: string;
    Warranty: IWarranty;
    Properties: any[];
    ExtensionProperties: any[];
    CustomerId: string;
}

interface IWarranty {
    DurationMonths: Number;
    ExpirationDate: string;
    Id: string;
    Name: string;
    StartDate: string;
}
export interface ICipDeviceDetailsResponse {
    device: ICipDeviceDetails | null;
    error: string | null;
}

const createInput = (args: Msdyn365.ICreateActionContext): Msdyn365.IActionInput => {
    return new GetDeviceDetailsInput();
};

const getDeviceIdFromUrl = () => {
    const url = window.location.href;
    const urlParam = new URLSearchParams(new URL(url).search);
    return urlParam.get('deviceId');
};

async function action(_: GetDeviceDetailsInput, ctx: Msdyn365.IActionContext): Promise<ICipDeviceDetailsResponse> {
    const userToken = ctx.requestContext.user.token === null ? 'USERTOKEN' : ctx.requestContext.user.token;

    const deviceId = getDeviceIdFromUrl();

    if (!deviceId) {
        return { device: null, error: 'No Device Id provided' };
    }

    const requestBody = { deviceId: deviceId, language: ctx.requestContext.locale };

    try {
        const response = await Msdyn365.sendRequest<ICipDeviceDetails>(
            `${ctx.requestContext.apiSettings.baseUrl}Commerce/GetDeviceDetail`,
            'post',
            requestBody,
            {
                headers: {
                    OUN: ctx.requestContext.apiSettings.oun,
                    Authorization: `id_token ${userToken}`
                }
            }
        );
        if (response.status === 200 && response.data) {
            return { device: response.data, error: null };
        }
        return { device: null, error: 'Static data from action' };
    } catch (error) {
        return { device: null, error: 'An error occured' };
    }
}

export default Msdyn365.createObservableDataAction({
    action: <Msdyn365.IAction<ICipDeviceDetailsResponse>>action,
    id: 'GetDeviceDetails',
    input: createInput
});
